// extracted by mini-css-extract-plugin
export default {"pageContent":"MagazinePage_pageContent__GYRds","main":"MagazinePage_main__qWQGO","mainColumn":"MagazinePage_mainColumn__X+Kbl","download":"MagazinePage_download__giXkp"};